import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getLeadTimePIRData = createApi(`GetLeadTimePIRSlice`,"GET");

const GetLeadTimePIRSlice = createSlice({
  name: 'GetLeadTimePIRSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLeadTimePIRData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLeadTimePIRData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getLeadTimePIRData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetLeadTimePIRSlice.reducer;